import { atom } from "jotai";

import {
  BookingWizardDataAtom,
  CurrentBookingWizardStepAtom,
  CurrentRequestGroupIndexAtom,
  ListOfBookingWizardStepsAtom,
} from "../../stores";

export const navigateToNextStepAtom = atom(null, (get, set) => {
  const currentStep = get(CurrentBookingWizardStepAtom);

  const steps = get(ListOfBookingWizardStepsAtom);

  const bookingWizardData = get(BookingWizardDataAtom);
  const currentRequestGroupIndex = get(CurrentRequestGroupIndexAtom);
  const requestGroupCount =
    bookingWizardData?.type === "RequestBooking"
      ? bookingWizardData.requestGroupCount ?? 1
      : 1;

  if (
    bookingWizardData?.type === "RequestBooking" &&
    requestGroupCount > 1 &&
    ["AddPlayers", "AddPlayersPrivate"].includes(currentStep ?? "") &&
    currentRequestGroupIndex < requestGroupCount - 1
  ) {
    set(CurrentRequestGroupIndexAtom, currentRequestGroupIndex + 1);
    return;
  }

  const stepIndex = steps?.findIndex((step) => step === currentStep);

  if (stepIndex !== undefined && stepIndex < steps?.length - 1) {
    const nextStep = steps[stepIndex + 1];
    set(CurrentBookingWizardStepAtom, nextStep);
  }
});
